interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function buildPages(page: number, totalPages: number): (number | "ellipsis")[] {
  const pages: (number | "ellipsis")[] = [];
  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i += 1) pages.push(i);
    return pages;
  }
  pages.push(1);
  if (page > 3) pages.push("ellipsis");
  const start = Math.max(2, page - 1);
  const end = Math.min(totalPages - 1, page + 1);
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (page < totalPages - 2) pages.push("ellipsis");
  pages.push(totalPages);
  return pages;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;
  const pages = buildPages(page, totalPages);

  return (
    <nav className="flex items-center justify-center gap-1.5 md:gap-2 flex-wrap mt-10 md:mt-14" aria-label="分页">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        className="h-9 px-3 md:px-4 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-700 flex items-center gap-1 whitespace-nowrap transition-colors cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed enabled:hover:bg-background-200"
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
        上一页
      </button>

      {pages.map((p, i) =>
        p === "ellipsis" ? (
          <span key={`e-${i}`} className="w-9 h-9 flex items-center justify-center text-foreground-500">
            …
          </span>
        ) : (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={`w-9 h-9 rounded-md text-sm font-label transition-colors cursor-pointer ${
              p === page
                ? "bg-primary-500 text-foreground-950"
                : "bg-background-100 border border-background-200 text-foreground-700 hover:bg-background-200"
            }`}
          >
            {p}
          </button>
        )
      )}

      <button
        type="button"
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
        className="h-9 px-3 md:px-4 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-700 flex items-center gap-1 whitespace-nowrap transition-colors cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed enabled:hover:bg-background-200"
      >
        下一页
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>
    </nav>
  );
}